angular.module('app.home', ['ui.router', 'app.home.kpi', 'app.home.timeline', 'app.home.lazypost'])

    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home.dashboard', {
                requireLogin: true,
                url: 'dashboard',
                templateUrl: 'app/home/partials/home.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
                    navMarker: ['dashboard'],
                },
                controller: 'HomeDashboardCtrl'
            })
    }])

    .controller('HomeDashboardCtrl', function ($scope, $rootScope, $window) {

        $scope.showData = $rootScope.saveParams ? true : false;

        //if the project is changed call new data for it
        $scope.$on('refreshDashboard', function (event, args) {
            $scope.showData = true;
        });

        $scope.$on('clearSelection', function (event, args) {
            $scope.showData = false;
        });

        $scope.$on('beforePrint', function (event, args) {
            setTimeout($window.print, 500);
        });
    })

    .controller('welcomeRegisterCtrl', function ($scope, $rootScope, $http, $stateParams, $modal, $state) {
        var definitions = angular.copy($rootScope.definitions);
        $scope.preLoaded = false;
        $scope.profile = {};

        $scope.agreeToS = function () {
            $scope.agreeToS = !$scope.agreeToS;
        }

        $scope.onPasswordType = function (password, confirmPassword) {
            var value = password === confirmPassword;
            $scope.signUpForm.confirmPassword.$setValidity('missMatch', value);
        };

        $scope.searchCountries = function (event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for (var i = 0; i < $scope.countries.length; i++) {
                    if ($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                        var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[i];
                        checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                        break;
                    }
                }
            }
        }

        $scope.preLoadData = function () {
            $scope.agreeToS = false;
            $scope.countries = definitions.countries;
            
            var data = {
                hashString: $stateParams.hashString
            };

            var req = {
                url: $rootScope.apiUrl + 'precheckHashLink',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function (response) {
                $scope.profile.email = response.data.email;
                $scope.profile.companyName = response.data.tempCompanyName;
            }).error(function (errResponse) {
                $scope.errors = errResponse;
            });
        }

        if (!$scope.preLoaded) {
            $scope.preLoadData();
        }

        $scope.acceptInvitation = function (isValid) {
            $scope.dataSignupLoading = true;
            if (isValid) {
                if ($scope.profile.fullName) {
                    var splitName = $scope.profile.fullName.split(" ")

                    if (splitName.length >= 2) {
                        $scope.profile.firstName = splitName[0];
                        $scope.profile.lastName = splitName[2] || splitName[1];
                    } else {
                        $scope.profile.firstName = splitName[0];
                        $scope.profile.lastName = "";
                    }
                }

                angular.forEach($scope.countries, function (val) {
                    if (val.ticked == true)
                        $scope.profile.country = val.id;
                })

                $scope.profile.packageSub = "PRO";

                var data = {
                    profile: $scope.profile,
                    hashString: $stateParams.hashString
                }

                $http.post($rootScope.apiUrl + 'acceptInvitation', data)
                    .success(function (data) {
                        $scope.dataSignupLoading = false;
                        var modalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/home/partials/successAcceptInvitationModal.html?app_v=deployDate',
                            controller: 'SuccessRegistrationCtrl'
                        });

                        $scope.modalInstance = modalInstance;
                        modalInstance.result.then(function () {
                            $state.go('landing.login');
                        }, function (reason) {
                            if (reason = 'escape key press') {
                                $state.go('landing.login');
                            }
                        });
                    })
                    .error(function (data) {
                        $scope.dataSignupLoading = false;
                        $scope.profileError = data.message;
                        $scope.errors = data;

                        for (var propertyKey in data) {
                            $("[ng-model='profile." + propertyKey + "']").addClass('ng-invalid')

                            return;
                        }
                    });
            } else {
                $scope.errorMessage = 'The form is not valid, please double check and try again.';
            }
        };
    })

    .controller('registerCtrl', function ($scope, $rootScope, $http, $stateParams, $modal, $state) {
        var definitions = angular.copy($rootScope.definitions);
        $scope.preLoaded = false;
        $scope.profile = {};

        $scope.agreeToS = function () {
            $scope.agreeToS = !$scope.agreeToS;
        }

        $scope.searchCountries = function (event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for (var i = 0; i < $scope.countries.length; i++) {
                    if ($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                        var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[i];
                        checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                        break;
                    }
                }
            }
        }

        $scope.preLoadData = function () {
            $scope.agreeToS = false;
            $scope.countries = definitions.countries;
        }

        if (!$scope.preLoaded) {
            $scope.preLoadData();
        }

        $scope.register = function (isValid) {
            $scope.dataSignupLoading = true;
            if (isValid) {
                //split name and last name
                if ($scope.profile.fullName) {
                    var splitName = $scope.profile.fullName.split(" ")

                    if (splitName.length >= 2) {
                        $scope.profile.firstName = splitName[0];
                        $scope.profile.lastName = splitName[2] || splitName[1];
                    } else {
                        //Ticket UB-44
                        $scope.profile.firstName = splitName[0];
                        $scope.profile.lastName = "";
                    }
                }

                angular.forEach($scope.countries, function (val) {
                    if (val.ticked == true)
                        $scope.profile.country = val.id;
                })

                $scope.profile.packageSub = "PRO";
                var data = {
                    profile: $scope.profile,
                    hashString: $stateParams.param
                }


                $http.post($rootScope.apiUrl + 'register', data)
                    .success(function (data) {
                        $scope.dataSignupLoading = false;

                        //send confirmation for successful registration
                        // $scope.successRegistrationMail();

                        //TODO : open modal first then upon closing modal to go to state landing.login
                        var modalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/home/partials/successRegistrationModal.html?app_v=deployDate',
                            controller: 'SuccessRegistrationCtrl'
                        });

                        $scope.modalInstance = modalInstance;
                        modalInstance.result.then(function () {
                            $state.go('landing.login');
                        }, function (reason) {
                            if (reason = 'escape key press') {
                                $state.go('landing.login');
                            }
                        });
                    })
                    .error(function (data) {
                        $scope.dataSignupLoading = false;
                        $scope.profileError = data.message;
                        $scope.errors = data;

                        for (var propertyKey in data) {
                            $("[ng-model='profile." + propertyKey + "']").addClass('ng-invalid')

                            return;
                        }
                    });
            } else {
                console.log("not valid")
            }
        };
    })

    .controller('SuccessRegistrationCtrl', ['$scope', '$modalInstance', '$modal',
        function ($scope, $modalInstance, $modal) {
            $scope.closeModal = function () {
                $modalInstance.close();
            }
        }])

    .controller('LoginCtrl', ['$http', 'ipCookie', '$scope', '$rootScope', '$location', 'AuthenticationService', 'userHandler', '$modal', 'localStorageService',
        function ($http, ipCookie, $scope, $rootScope, $location, AuthenticationService, userHandler, $modal, localStorageService) {
            //check if user is logged-in
            if (localStorageService.cookie.isSupported) {
                if (typeof (ipCookie("access_token_expiration")) != 'undefined') {
                    $location.path('/dashboard');
                }
            } else {
                if (localStorageService.get('access_token_expiration')) {
                    $location.path('/dashboard');
                }
            }

            $scope.login = function () {
                $scope.dataLoading = true;
                userHandler.authenticateUser($scope.username, $scope.password, $scope.dataLoading).then(function (data) {
                    
                }, function (data) {
                    $scope.error = data ? data.message : "";
                    $scope.dataLoading = false;
                })
            };

            $scope.forgotPasswordModalHandler = function () {
                var forgotPasswordModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/home/partials/fotgot_password.html?app_v=deployDate',
                    controller: 'ForgotPasswordCtrl',
                });

                $scope.forgotPasswordModalInstance = forgotPasswordModalInstance;
            }
        }])

    .controller('AuthorizeByTokenCtrl', ['$http', 'ipCookie', '$scope', '$rootScope', '$location', 'AuthenticationService', 'userHandler', '$modal', 'localStorageService', '$state', '$stateParams',
        function ($http, ipCookie, $scope, $rootScope, $location, AuthenticationService, userHandler, $modal, localStorageService, $state, $stateParams) {
            if(!$stateParams.token) {
                $location.path('/login');
            }

            var token = $stateParams.token;
            $scope.dataLoading = true;
            userHandler.authenticateUserByToken(token, $scope.dataLoading).then(function (data) {
                
            }, function (data) {
                $scope.error = data ? data.message : "";
                $scope.dataLoading = false;
            })
        }])

    .factory('userHandler', ['$rootScope', '$http', 'localStorageService', 'AuthenticationService', 'ipCookie', '$location', '$q',
        function ($rootScope, $http, localStorageService, AuthenticationService, ipCookie, $location, $q) {
            return {
                authenticateUser: function (email, password, loading) {
                    return $q(function (resolve, rejact) {

                        $rootScope.autoSelectProject = false;

                        AuthenticationService.Login(email, password)
                            .then(function (data) {

                                localStorageService.set('access_token', data.Authorization);

                                var et = data.expiration_time;
                                var expirationDate = new Date(et.split(' ').join('T'));
                                var expirationSeconds = (expirationDate.getTime() / 1000) - Math.floor(Date.now() / 1000);

                                if (localStorageService.cookie.isSupported) {
                                    ipCookie("access_token_expiration", et, {
                                        expirationUnit: 'seconds',
                                        expires: expirationSeconds
                                    });
                                } else {
                                    localStorageService.set('access_token_expiration', et, 'memory');
                                }

                                AuthenticationService.getCurrentUser(loading);

                                resolve({ status: 'ok' });
                            }, function (data, status) {
                                rejact(data);
                            })
                    })
                },
                authenticateUserByToken: function (accessToken, loading) {
                    return $q(function (resolve, rejact) {

                        $rootScope.autoSelectProject = false;

                        AuthenticationService.LoginByAccessToken(accessToken)
                            .then(function (data) {

                                localStorageService.set('access_token', data.Authorization);

                                var et = data.expiration_time;
                                var expirationDate = new Date(et.split(' ').join('T'));
                                var expirationSeconds = (expirationDate.getTime() / 1000) - Math.floor(Date.now() / 1000);

                                if (localStorageService.cookie.isSupported) {
                                    ipCookie("access_token_expiration", et, {
                                        expirationUnit: 'seconds',
                                        expires: expirationSeconds
                                    });
                                } else {
                                    localStorageService.set('access_token_expiration', et, 'memory');
                                }

                                AuthenticationService.getCurrentUser(loading).then(function(data){
                                    // var currentUser = localStorageService.get("currentUser");
                                    // if(currentUser) {
                                    //     currentUser
                                    // }
                                });

                                resolve({ status: 'ok' });
                            }, function (data, status) {
                                rejact(data);
                            })
                    })
                }
            }
        }])

    .controller('ForgotPasswordCtrl', ['$scope', '$rootScope', '$http', '$modalInstance',
        function ($scope, $rootScope, $http, $modalInstance) {
            $scope.resetPasswordMessage = "";
            $scope.resetPasswordError = "";

            $scope.sendInstructionMail = function () {
                $scope.dataLoading = true;
                $scope.resetPasswordMessage = "";
                $scope.resetPasswordError = "";

                var data = {
                    userEmail: $scope.email,
                    hostName: window.location.hostname
                }

                var req = {
                    url: $rootScope.apiUrl + 'forgotPassword',
                    method: 'POST',
                    data: JSON.stringify(data)
                }

                $http(req).success(function (response) {
                    // $scope.forgotPasswordModalInstance.close();
                    $scope.resetPasswordMessage = "The link to reset password is sent to your email!";
                    $scope.dataLoading = false;
                }).error(function (data) {
                    $scope.resetPasswordError = "Cannot send email! Please try again!";
                    $scope.dataLoading = false;
                    return false;
                })
            }
        }])

    .controller('WelcomeToCampaignCtrl', ['$scope', '$rootScope', '$stateParams', '$q', '$http', 'userHandler', 'CampaignFormService',
        function ($scope, $rootScope, $stateParams, $q, $http, userHandler, CampaignFormService) {
            var me = this;

            function handleRequest(url, method, params, loader, token) {
                var deferred = $q.defer();

                function checkResponse(data) {
                    return data;
                };

                var req = {
                    headers: {'Authorization': token},
                    url: url,
                    method: method,
                    data: JSON.stringify(params),
                    loader: loader
                }

                $http(req).success(function (data, status) {
                    if (status === 204) {
                        deferred.resolve(data);
                    }

                    var dataRes = angular.fromJson(data);

                    if (checkResponse(dataRes)) {
                        deferred.resolve(dataRes);
                    } else {
                        deferred.reject(getMessage(dataRes));
                    }
                })
                .error(function (error, status) {
                    error = error || {};
                    error.status = status;
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            function getInfluencerInterestedCampaign (campaignId, loader) {
                var url = $rootScope.apiUrl + 'campaign/getInfluencerInterestedCampaign/' + campaignId;
                return handleRequest(url, 'GET', null, loader, me.token);
            }

            var loadCampaignDetail = function (campaignId) {
                getInfluencerInterestedCampaign(campaignId, true)
                    .then(function(res){
                        me.campaignDetail = res.data;
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
            };

            var startIntercom = function () {
                window.Intercom("boot", {
                    app_id: "fkhiga69",
                    name: me.campaignDetail.influencerName,
                    email: me.campaignDetail.influencerEmail,
                    //created_at: $rootScope.currentUser.timestamp // Signup date as a Unix timestamp
                });
            };


            (function init() {
                me.token = $stateParams.token;
                me.campaignInfluencerId = $stateParams.campaignInfluencerId;
                loadCampaignDetail(me.campaignInfluencerId);
                me.startIntercom = startIntercom;
                $scope.isShowMore = false;
            })();
        }
    ]);




